var Marionette = require('marionette')
var App = require('app')
// var LeafletSleep = require('leaflet-sleep')

var MapSimpleModule = Marionette.Object.extend({
  initialize: function (options) {
    var self = this
    var config = App.config.maps

    var defaultOptions = {
      'accessToken': config.accessToken,
      'container': 'map',
      'zoomLevel': 2,
      'style': config.style,
      'minZoom': config.minZoom,
      'maxZoom': config.maxZoom,
      'mapOptions': {
        // scrollWheelZoom: false,
        // false if you want an unruly map
        sleep: true,
        // time(ms) until map sleeps on mouseout
        sleepTime: 750,
        // time(ms) until map wakes on mouseover
        wakeTime: 750,
        // should the user receive wake instrurctions?
        sleepNote: false,
        // should hovering wake the map? (non-touch devices only)
        hoverToWake: false,
        // a message to inform users about waking the map
        wakeMessage: 'Click or Hover to Wake',
        // a constructor for a control button
        // sleepButton: L.Control.sleepMapControl,
        // opacity for the sleeping map
        sleepOpacity: 1
      }

    }

    options = _.extend(defaultOptions, options)
    console.log(options)
    //
    L.mapbox.accessToken = options.accessToken
    this.map = L.mapbox.map(options.container, false, options.mapOptions).setView(options.location, options.zoomLevel)
    this.markers = {}

    // style
    L.mapbox.styleLayer(
      options.style,
      {
        'minZoom': options.minZoom,
        'maxZoom': options.maxZoom
      }
    ).addTo(this.map)
  },
  getInstance: function () {
    return this.map
  },
  setPosition: function (location) {
    this.map.setView(location, 16)
  },
  setMarkerPosition: function (markerId, position) {
    var marker = this.markers[markerId]
    if (!marker) return false
    marker.setLatLng(position)
  },
  addMarker: function (location, options) {
    var self = this

    var markerOptions = {
      draggable: false,
      icon: L.mapbox.marker.icon(
          { 'marker-color': '#f86767' }
        )
    }

    if (options.mapBoxOptions) {
      _.extend(markerOptions, options.mapBoxOptions)
    }

    var marker = L.marker(location, markerOptions)

    if (options.onDragEnd) {
      marker.on('dragend', options.onDragEnd)
    }

    marker.addTo(this.map)

    if (options.id) {
      this.markers[options.id] = marker
    }

    return marker
  }
})

module.exports = MapSimpleModule



// WEBPACK FOOTER //
// ./js/common/mapSimple.js